import { AvailableDeliveryMethodsDetail } from "interfaces/session/ShoppingCart";

export function selectedDeliveryMethodDetails(selectedDeliveryMethod: string,
  availableDeliveryMethodsDetails: AvailableDeliveryMethodsDetail[]): AvailableDeliveryMethodsDetail {
  const deliverMethodDetails = availableDeliveryMethodsDetails?.find(
    (el: AvailableDeliveryMethodsDetail) => (el.deliveryMethod === selectedDeliveryMethod),
  );
  return deliverMethodDetails;
}
